import React from "react";
import { APP_ID } from "../utils/constants";
import useGetProductCategories from "../hooks/useGetProductCategories";
import MuPb from "../widgets/MuPb";
import { getErrorResponse } from "../utils/util";
import { Alert, Box, Container, Typography } from "@mui/material";
import CategorySelectorAccordions from "../formbuilder/widgets/CategorySelectorAccordions";
import { Link, useParams } from "react-router-dom";

const ProductCategoriesView = () => {
  const { id } = useParams();
  return (
    <Container maxWidth="md" sx={{ my: 3 }}>
      <Typography variant="h6">You have currenty uploaded:</Typography>
      <CategorySelectorAccordions onSelectionChange={() => {}} />
      <Box mt={2}>
        <Link to={`/choose-category-options/${id}`}>Click here to update</Link>
      </Box>
    </Container>
  );
};

export default ProductCategoriesView;
